const KEY = "GA_LOCAL_INVENTORY"

function storeInventoryLocally(inventory) {
  localStorage.setItem(KEY, JSON.stringify(inventory))
}

function loadLocalInventory() {
  return JSON.parse(localStorage.getItem(KEY))
}

function clearLocalInventory() {
  localStorage.removeItem(KEY)
}

export const localInventory = {
  store: storeInventoryLocally,
  load: loadLocalInventory,
  clear: clearLocalInventory,
}
